<template>
<article id="docs" class="programs-fb-docs n-pt-1 programs-fb__section">
    <h2 v-html="items.name" class="programs-fb-docs__title h-32 h-t-22 h-m-18 fw-semi" />
    <p class="programs-fb-docs__subtitle">Реализация региональных ипотечных программ с участием АО «ДОМ.РФ» в
        качестве оператора — это:</p>
    <ul class="programs-fb-docs__lists">
        <li class="programs-fb-docs__list--item">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10 20.0002C15.5228 20.0002 20 15.5231 20 10.0002C20 4.4774 15.5228 0.000244141 10 0.000244141C4.47715 0.000244141 0 4.4774 0 10.0002C0 15.5231 4.47715 20.0002 10 20.0002ZM13.1655 7.37402C13.556 6.98349 14.1892 6.98349 14.5797 7.37402L14.7369 7.53115C15.1274 7.92168 15.1274 8.55484 14.7369 8.94536L10.7299 12.9523L9.15857 11.381L13.1655 7.37402ZM10.7299 12.9523L9.15849 14.5237L5.15155 10.5167C4.76103 10.1262 4.76103 9.49303 5.15155 9.1025L5.30869 8.94536C5.69921 8.55484 6.33237 8.55484 6.7229 8.94536L10.7299 12.9523Z"
                    fill="#82BF00" />
            </svg>
            <span class="programs-fb-docs__list--text">Единый стандарт реализации</span>
        </li>
        <li class="programs-fb-docs__list--item">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10 20.0002C15.5228 20.0002 20 15.5231 20 10.0002C20 4.4774 15.5228 0.000244141 10 0.000244141C4.47715 0.000244141 0 4.4774 0 10.0002C0 15.5231 4.47715 20.0002 10 20.0002ZM13.1655 7.37402C13.556 6.98349 14.1892 6.98349 14.5797 7.37402L14.7369 7.53115C15.1274 7.92168 15.1274 8.55484 14.7369 8.94536L10.7299 12.9523L9.15857 11.381L13.1655 7.37402ZM10.7299 12.9523L9.15849 14.5237L5.15155 10.5167C4.76103 10.1262 4.76103 9.49303 5.15155 9.1025L5.30869 8.94536C5.69921 8.55484 6.33237 8.55484 6.7229 8.94536L10.7299 12.9523Z"
                    fill="#82BF00" />
            </svg>
            <span class="programs-fb-docs__list--text">Гарантия исполнения обязательств перед
                кредиторами–участниками</span>
        </li>
        <li class="programs-fb-docs__list--item">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10 20.0002C15.5228 20.0002 20 15.5231 20 10.0002C20 4.4774 15.5228 0.000244141 10 0.000244141C4.47715 0.000244141 0 4.4774 0 10.0002C0 15.5231 4.47715 20.0002 10 20.0002ZM13.1655 7.37402C13.556 6.98349 14.1892 6.98349 14.5797 7.37402L14.7369 7.53115C15.1274 7.92168 15.1274 8.55484 14.7369 8.94536L10.7299 12.9523L9.15857 11.381L13.1655 7.37402ZM10.7299 12.9523L9.15849 14.5237L5.15155 10.5167C4.76103 10.1262 4.76103 9.49303 5.15155 9.1025L5.30869 8.94536C5.69921 8.55484 6.33237 8.55484 6.7229 8.94536L10.7299 12.9523Z"
                    fill="#82BF00" />
            </svg>
            <span class="programs-fb-docs__list--text">Равные условия участия для кредиторов-участников при реализации
                государственных ипотечных программ</span>
        </li>
        <li class="programs-fb-docs__list--item">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10 20.0002C15.5228 20.0002 20 15.5231 20 10.0002C20 4.4774 15.5228 0.000244141 10 0.000244141C4.47715 0.000244141 0 4.4774 0 10.0002C0 15.5231 4.47715 20.0002 10 20.0002ZM13.1655 7.37402C13.556 6.98349 14.1892 6.98349 14.5797 7.37402L14.7369 7.53115C15.1274 7.92168 15.1274 8.55484 14.7369 8.94536L10.7299 12.9523L9.15857 11.381L13.1655 7.37402ZM10.7299 12.9523L9.15849 14.5237L5.15155 10.5167C4.76103 10.1262 4.76103 9.49303 5.15155 9.1025L5.30869 8.94536C5.69921 8.55484 6.33237 8.55484 6.7229 8.94536L10.7299 12.9523Z"
                    fill="#82BF00" />
            </svg>
            <span class="programs-fb-docs__list--text">Единая информационная платформа для взаимодействия участников
                региональных ипотечных программ</span>
        </li>
        <li class="programs-fb-docs__list--item">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10 20.0002C15.5228 20.0002 20 15.5231 20 10.0002C20 4.4774 15.5228 0.000244141 10 0.000244141C4.47715 0.000244141 0 4.4774 0 10.0002C0 15.5231 4.47715 20.0002 10 20.0002ZM13.1655 7.37402C13.556 6.98349 14.1892 6.98349 14.5797 7.37402L14.7369 7.53115C15.1274 7.92168 15.1274 8.55484 14.7369 8.94536L10.7299 12.9523L9.15857 11.381L13.1655 7.37402ZM10.7299 12.9523L9.15849 14.5237L5.15155 10.5167C4.76103 10.1262 4.76103 9.49303 5.15155 9.1025L5.30869 8.94536C5.69921 8.55484 6.33237 8.55484 6.7229 8.94536L10.7299 12.9523Z"
                    fill="#82BF00" />
            </svg>
            <span class="programs-fb-docs__list--text">Единая и стандартизированная форма отчетности</span>
        </li>
    </ul>
    <p class="programs-fb-docs__sub p-16 p-m-14">
        <span v-html="items.description" />
    </p>
    <div class="programs-fb-docs-tabs">
        <div v-if="!isMobile" class="programs-fb-docs-tabs__head">
            <template v-for="tab in tabs" :key="tab.id">
                <button @click.prevent="changeTab(tab.id, tab.description)" :class="{
                    '_no-hover _dark _no-events': curTab === tab.id
                }" href="#!" class="u-btn _middle">{{ tab.name }}</button>
            </template>
        </div>
        <div v-else class="programs-fb-docs-tabs__head">
            <my-select v-if="tabs.length" v-model="selectedTab" select-class="programs-fb-docs-tabs__select"
                :options='tabs' no-clear-button />
        </div>
    </div>
    <p v-if="tabDescr" v-html="tabDescr" class="programs-fb-docs-tabs__descr p-16 p-m-14 fw-semi" />
    <div class="programs-fb-docs__items">
        <div v-for="(item, idx) in curItems" :key="`doc-${idx}`" class="e-doc-cell">
            <p class="e-doc-cell__title g-text__p">{{ item.name }}</p>
            <div class="e-doc-cell__info u-link__download">
                <span class="text-uppercase">{{ item.file.extension }},</span> {{ item.file.size }}
            </div>
            <a v-if="item.file" :href="item.file.src" :download="`${item.name}.${item.file.extension}`"
                class="e-doc-cell__link" target="_blank"></a>
        </div>
    </div>
    <div v-if="allPages > curPage" class="programs-fb-docs__more">
        <a href="#!" @click="showMore" class="u-link js-show-more-event">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_11_15424)">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10 3.06674C8.16117 3.06674 6.39765 3.79721 5.09739 5.09746C3.79714 6.39772 3.06667 8.16124 3.06667 10.0001H2C1.99979 8.39196 2.48423 6.82111 3.39011 5.49243C4.296 4.16375 5.58129 3.13892 7.07833 2.55162C8.57536 1.96432 10.2146 1.84182 11.7823 2.2001C13.35 2.55837 14.7734 3.38079 15.8667 4.56007V2.00007H16.9333V6.26674H12.6667V5.20007H15.0027C14.3564 4.52467 13.5798 3.98739 12.72 3.6207C11.8601 3.25402 10.9348 3.06557 10 3.06674V3.06674ZM10 16.9334C10.9105 16.9334 11.8121 16.7541 12.6533 16.4056C13.4945 16.0572 14.2588 15.5465 14.9026 14.9027C15.5464 14.2589 16.0571 13.4945 16.4056 12.6533C16.754 11.8122 16.9333 10.9106 16.9333 10.0001H18C18 11.6081 17.5154 13.1788 16.6094 14.5073C15.7035 15.8358 14.4182 16.8605 12.9212 17.4477C11.4242 18.0348 9.785 18.1572 8.21741 17.7989C6.64981 17.4406 5.22658 16.6182 4.13333 15.439V18.0001H3.06667V13.7334H7.33333V14.8001H4.99733C5.64361 15.4755 6.42016 16.0128 7.28003 16.3794C8.1399 16.7461 9.06521 16.9346 10 16.9334V16.9334Z"
                        fill="currentColor"></path>
                </g>
                <defs>
                    <clippath id="clip0_11_15424">
                        <rect width="16" height="16" fill="currentColor" transform="translate(2 2)"></rect>
                    </clippath>
                </defs>
            </svg>
            <span class="g-text__p _semibold">Показать еще</span>
        </a>
    </div>
</article>
</template>

<script>
import MySelect from "../ui/MySelect";

export default {
    name: 'DocsForBusiness',
    components: { MySelect },
    props: {
        items: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            curPage: 1,
            allPages: 1,
            perPage: 8,
            allItems: [],
            allSections: null,
            tabs: [],
            curTab: '',
            isMobile: window.innerWidth < 768,
            selectedTab: [],
            tabDescr: ''
        }
    },
    computed: {
        curItems() {
            return this.allItems.slice(0, this.curPage * this.perPage);
        }
    },
    watch: {
        selectedTab(newVal, oldVal) {
            const tab = newVal[0];

            if (tab?.id && (tab.id !== oldVal[0]?.id)) {
                this.changeTab(tab?.id, tab?.description);
            }
        }
    },
    methods: {
        showMore() {
            this.curPage = this.curPage + 1;
        },
        changeTab(tabIdx, tabDescription) {
            this.allItems = [];
            this.curPage = 1;

            if (this.allSections[tabIdx] !== 'undefined') {
                this.allSections[tabIdx].items.forEach((item) => {
                    this.allItems.push(item);
                });
                this.tabDescr = tabDescription;
            } else {
                console.error('Раздел и табуляция не сходятся');
                return;
            }

            this.curTab = tabIdx;
            this.allPages = Math.ceil(this.allItems?.length / this.perPage);
            this.$emit('showLimitTable', this.curTab);
        }
    },
    mounted() {
        let i = 0;
        this.allSections = this.items?.sections;

        for (const key in this.allSections) {
            const item = this.allSections[key];

            this.tabs.push({
                name: item.name,
                id: item.id,
                description: item.description,
                value: item.id, // for mobile select
                text: item.name // for mobile select
            });

            if (i === 0) {
                item.items.forEach((sub) => {
                    this.allItems.push(sub);
                });
            }
            i++;
        }

        this.curTab = this.tabs[0]?.id;
        this.allPages = Math.ceil(this.allItems?.length / this.perPage);
    }
}
</script>
